import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { RecommendedProductsType } from '~app/modules/catalog/models';
import { Product } from '~shared/models';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import {
  ProductClickApplicationEvent,
  AlternativeProductsShowApplicationEventModel
} from '~shared/modules/application-event/models';
import { PageNameTypes } from '~shared/modules/application-event/constants';
import { RECOMMENDED_PRODUCTS_TITLE } from '~app/modules/catalog/constants';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { BlackDealsFeatureFlagService } from '~shared/services/black-deals-feature-flag.service';
import { NavigationHelper } from '~shared/services/navigation-helper.service';

@Component({
  selector: 'app-catalog-recommended-products',
  templateUrl: './recommended-products.component.html',
  styleUrls: ['./recommended-products.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class RecommendedProductsComponent implements AfterViewInit {
  @Input() products: Product[];
  @Input() type: RecommendedProductsType;
  titleMap = Object.keys(RECOMMENDED_PRODUCTS_TITLE).reduce((prev, cur) => {
    return {
      ...prev,
      [RecommendedProductsType[cur]]: RECOMMENDED_PRODUCTS_TITLE[cur],
    };
  }, {});

  constructor(
    private applicationEventService: ApplicationEventService,
    private blackDealsFeatureFlagService: BlackDealsFeatureFlagService,
    private navigationHelper: NavigationHelper
  ) {
  }

  ngAfterViewInit(): void {
    this.fireAlternativeProductsShowEvent(this.getPageName());
  }

  onProductClick(product: Product, priceType: PriceTypes, i: number): void {
    this.applicationEventService.publish(
      new ProductClickApplicationEvent(
        this.navigationHelper.getCurrentUrl(),
        product,
        priceType,
        this.getPageName(),
        this.blackDealsFeatureFlagService.isBlackDealsEnabled(),
        i
      )
    );
  }

  private getPageName(): PageNameTypes {
    switch (this.type) {
      case RecommendedProductsType.ParentCategory:
        return PageNameTypes.CategoryAlternativeProducts;
      case RecommendedProductsType.PromoItems:
        return PageNameTypes.PromotionAlternativeProducts;
      case RecommendedProductsType.RemovedFilters:
        return PageNameTypes.FilterAlternativeProducts;
      case RecommendedProductsType.ExpandedSearch:
        return PageNameTypes.ExpandedSearchAlternativeProducts;
      case RecommendedProductsType.MostPopularProducts:
        return PageNameTypes.MostPopularProducts;
      case RecommendedProductsType.MostRelevantProducts:
        return PageNameTypes.MostRelevantProducts;
      case RecommendedProductsType.ParsedTextProducts:
        return PageNameTypes.ParsedTextProducts;
      default:
        console.warn('Unable to find recommended product type ', this.type);
        return null;
    }
  }

  private fireAlternativeProductsShowEvent(pageName: PageNameTypes): void {
    this.applicationEventService.publish(
      new AlternativeProductsShowApplicationEventModel(
        pageName
      )
    );
  }
}
